import Icons from "../Icons/Icons";
import Logo from "../Logo/Logo";
import { useRef, useEffect } from "react";
import { useStore } from "../../store/store";
import { gsap } from "gsap";
import s from "./Header.module.scss";

const Header = () => {
  const navRef = useRef();
  const loadingScreen = useStore((state) => state.loadingScreen);

  useEffect(() => {
    if (loadingScreen === false) {
      gsap.to(navRef.current, {
        opacity: 1,
        duration: 1,
      });
    }
  }, [loadingScreen]);

  return (
    <nav ref={navRef} className={s.nav}>
      <Logo />
      <Icons />
    </nav>
  );
};

export default Header;
